import { useEditorMaybe } from '@grapesjs/react';
import { Box, Dialog, DialogActions, DialogContent, DialogContentText, TextField } from '@mui/material';
import { useCallback } from 'react';
import { AgButton } from 'src/components/ui';

export default function PalletTagStorageSaveModal({ open, onClose, templateName, setTemplateName }) {
  const editor = useEditorMaybe();

  const handleSaveConfirm = useCallback(() => {
    editor.store({ remote: true, templateName });
    onClose();
  }, [editor, onClose, templateName]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogContent>
        <DialogContentText>Save changes to tag layout?</DialogContentText>
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            fullWidth
            label="Document Name"
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <AgButton variant="ghost" onPress={onClose}>
          Cancel
        </AgButton>
        <AgButton isDisabled={!templateName?.trim()} onPress={handleSaveConfirm}>
          Save
        </AgButton>
      </DialogActions>
    </Dialog>
  );
}
